module.exports = __webpack_public_path__ + "media/images/147years.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/147years.jpg
// module id = 61
// module chunks = 0